import { actionCreator, persistentReducedStream, reducer } from 'rxbeach';

export const adminSetActive = actionCreator<any>('[admin] set active');

export const admin$ = persistentReducedStream<{ active: any }>(
  'admin',
  { active: null },
  [
    reducer(adminSetActive, (_: any, active) => ({ active })),
  ]);
